__turbopack_context__.v({
  "active": "style-module-scss-module__-T87Na__active",
  "active-option": "style-module-scss-module__-T87Na__active-option",
  "component": "style-module-scss-module__-T87Na__component",
  "custom-input-container": "style-module-scss-module__-T87Na__custom-input-container",
  "dark": "style-module-scss-module__-T87Na__dark",
  "filter-controls": "style-module-scss-module__-T87Na__filter-controls",
  "input-container": "style-module-scss-module__-T87Na__input-container",
  "inputs": "style-module-scss-module__-T87Na__inputs",
  "options": "style-module-scss-module__-T87Na__options",
  "up-side-down": "style-module-scss-module__-T87Na__up-side-down",
});
